import alert_mixin from '@/utils/mixins/alert_mixin';
import DependentQuestionsPanel from '@/components/config_components/DependentQuestions/DependentQuestionsPanel.vue';
import DragHandle from './DragHandle.vue';
import { create_sections_data } from './create_sections_data';
import { create_sections_computed } from './create_sections_computed';
import { create_sections_verification_methods } from './create_sections_verification_methods';
import { create_sections_normalization_methods } from './create_sections_normalization_methods';
import { create_sections_reorder_methods } from './create_sections_reorder_methods';
import { create_sections_assignment_methods } from './create_sections_assignment_methods';
import { create_sections_modal_methods } from './create_sections_modal_methods';
import { create_sections_question_form_methods } from './create_sections_question_form_methods';
import { create_sections_section_crud_methods } from './create_sections_section_crud_methods';
import { create_sections_question_crud_methods } from './create_sections_question_crud_methods';
import { fetch_form, update_form_instructions } from '@/services/form_service';

function build_component_data() {
  return create_sections_data();
}

export default {
  name: 'CreateSections',
  mixins: [alert_mixin],
  components: {
    DragHandle,
    DependentQuestionsPanel,
  },
  data() {
    return build_component_data();
  },
  computed: create_sections_computed,
  async created() {
    const form_id = this.$route?.query?.form_id;
    const form_name = this.$route?.query?.form_name;
    const verification_form_id = this.$route?.query?.verification_form_id;

    if (form_id) this.topBar.formId = String(form_id);
    if (form_name) this.topBar.formName = String(form_name);
    if (verification_form_id) this.verification_form_id = String(verification_form_id);

    await Promise.all([
      this.$store.dispatch('ensureFormMetadataLoaded'),
      this.load_main_sections(),
      this.load_form_sections(),
      this.load_reusable_section_catalogs(),
    ]).catch((error) => console.warn('Failed to load form sections', error));

    try {
      const form = await fetch_form(form_id);
      this.form_instructions = Array.isArray(form?.form_instructions) ? form.form_instructions : [];
    } catch (error) {
      console.warn('Failed to load form instructions', error);
    }

    await this.load_verification_guidance();
  },
  methods: {
    ...create_sections_verification_methods,
    ...create_sections_normalization_methods,
    ...create_sections_reorder_methods,
    ...create_sections_assignment_methods,
    ...create_sections_modal_methods,
    ...create_sections_question_form_methods,
    ...create_sections_section_crud_methods,
    ...create_sections_question_crud_methods,
    async persist_form_instructions() {
      await update_form_instructions(this.topBar.formId, this.form_instructions);
    },
  },
};
